import Airdrop from "@/components/layout/home/Airdrop";
import AirdropBASE from "@/components/layout/home/AirdropBASE";
import Deposit from "@/components/layout/home/Deposit";
import Rewards from "@/components/layout/home/Rewards";
import RewardsMatchingBonus from "@/components/layout/home/RewardsMatchingBonus";
import RewardsMatchingBonusBASE from "@/components/layout/home/RewardsMatchingBonusBASE";
import Sponsor from "@/components/layout/home/Sponsor";
import Update from "@/components/layout/home/Update";
import UserInfo from "@/components/layout/home/UserInfo";
import Vesting from "@/components/layout/home/Vesting";
import { useUserStore } from "@/modules/auth/store/user";
import WebApp from "@twa-dev/sdk";

const Home = () => {
  const {
    vesting,
    matchingBonus,
    matchingBonusBASE,
    isMatchingBonusLoading,
    isMatchingBonusLoadingBASE,
  } = useUserStore();
  const isMiniApp = !!WebApp.initData;

  const hideUpdate = sessionStorage.getItem("hideUpdate") === "true";

  return (
    <>
      <UserInfo />

      {parseFloat(WebApp.version) < 8.0 && isMiniApp && !hideUpdate && (
        <Update />
      )}

      <Deposit />

      <div className="flex flex-col gap-4 p-4">
        <Sponsor />

        <Rewards />

        {!isMatchingBonusLoading &&
          matchingBonus.nextEndTimeWithdraw !== "" && <RewardsMatchingBonus />}

        {!isMiniApp &&
          !isMatchingBonusLoadingBASE &&
          matchingBonusBASE.nextEndTimeWithdraw !== "" && (
            <RewardsMatchingBonusBASE />
          )}

        <div className="flex flex-col gap-2">
          {/* {activated && <YourReferral />} */}
          <Airdrop />

          {!isMiniApp && <AirdropBASE />}
        </div>

        {Boolean(vesting && vesting.totalTokenAmount > 0.0) && <Vesting />}
      </div>
    </>
  );
};

export default Home;
